<template>
  <Container id="container-formulario">
    <b-row>
      <b-col cols="12">
        <div
          class="bg-light px-4 py-3 text-morado-claro text-left mt-3 mt-lg-0 mx-3 mx-lg-0 d-flex"
        >
          <FontAwesomeIcon icon="info" class="mr-1" />
          <span class="border-left pl-3 text-justify">
            <b>La vitrina de establecimientos</b> permite ver las
            características de todos los colegios participantes del sistema de
            admisión escolar, tales como, copago, género, subvención, programa
            de integración escolar, SIMCE, categoría de desempeño, actividades
            extracurriculares, entre otros. <br />Para buscar, puede filtrar por
            región, comuna y nivel, como también, por filtros personalizados.
            <br />Aprovecha esta herramienta para conocer los establecimientos
            que te interesan.</span
          >
          <!--La información institucional, ubicación, vacantes, jornadas y programas es responsabilidad del establecimiento-->
        </div>
      </b-col>
    </b-row>
    <FormBusqueda
      id="form-busqueda"
      @cambiarComuna="setComuna"
      @cambiarRegion="setRegion"
      @cambiarNivel="setNivel"
      @cambiarNombre="setNombreBusqueda"
      @toggleFiltrosDesktop="displayFiltros = !displayFiltros"
    />
    <FiltrosDesktop
      :show="displayFiltros"
      v-if="comuna != null"
      ref="filtroDesktop"
      @aplicarFiltros="modificarFiltros"
    />
    <FiltrosMovil @aplicarFiltros="modificarFiltros" v-if="comuna != null" />
    <!-- Boton buscar , para interfaz movil -->
    <div class="pt-4 pb-4 d-block d-md-none text-center" v-if="comuna != null">
      <b-link
        href="#barra-tags"
        class="btn-lg btn-azul-oscuro gilmer text-uppercase text-white w-75 d-block mx-auto font-weight-bold"
        >Buscar</b-link
      >
    </div>
    <BarraTags
      id="barra-tags"
      :filtros="getFiltros"
      :orden="criterioOrden"
      :numeroEstablecimientos="establecimientos.length"
      @removerFiltro="removerFiltro"
    />
    <BotoneraNavegacion
      :orden="criterioOrden"
      :tabSeleccionada="vista"
      @toggleVista="cambiarVista"
      @cambioCriterioOrden="cambiarOrden"
    />
    <Iconografia />
    <div id="placas-resultados" class="px-3 px-lg-0">
      <DetalleEstablecimientos
        v-show="tipoVista === 'detalle'"
        :establecimientos="establecimientos"
      />
      <ListaEstablecimientos
        v-show="tipoVista === 'lista'"
        :establecimientos="establecimientos"
      />
      <Mapa
        v-show="tipoVista === 'mapa'"
        :vista="tipoVista"
        :establecimientos="establecimientos"
      />
    </div>
    <Flecha />
  </Container>
</template>

<script>
import Flecha from "@/components/generales/Flecha";
import ApiRegiones from "@/services/ApiRegiones";
import ApiEstablecimientos from "@/services/ApiEstablecimientos";
import Container from "@/components/wrapper/Container";
import Filtros from "@/utils/Filtros";
import BarraTags from "@/components/busqueda/filtros/BarraTags";
import BotoneraNavegacion from "@/components/busqueda/BotoneraNavegacion";
import DetalleEstablecimientos from "@/components/busqueda/establecimientos/DetalleEstablecimientos.vue";
import ListaEstablecimientos from "@/components/busqueda/establecimientos/ListaEstablecimientos.vue";
import FiltrosDesktop from "@/components/busqueda/filtros/FiltrosDesktop";
import FiltrosMovil from "@/components/busqueda/filtros/FiltrosMovil";
import FormBusqueda from "@/components/busqueda/FormBusqueda";
import Mapa from "@/components/busqueda/establecimientos/Mapa";
import Iconografia from "@/components/generales/Iconografia";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch,
  faSlidersH,
  faAngleUp
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapGetters } from "vuex";
library.add(faSearch, faSlidersH, faAngleUp);
export default {
  //props
  beforeCreate() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  //components
  components: {
    Flecha,
    Container,
    BarraTags,
    BotoneraNavegacion,
    DetalleEstablecimientos,
    FiltrosDesktop,
    FiltrosMovil,
    FontAwesomeIcon,
    FormBusqueda,
    ListaEstablecimientos,
    Mapa,
    Iconografia
  },

  //data
  data() {
    return {
      etapaProceso: localStorage.getItem("etapaVitrina") || "NORMAL",
      //flag para mostrar o ocultar interfaz de filtros desktop
      displayFiltros: false,
      //almacena la vista activa en el panel inferior
      tipoVista: "detalle",
      //almacena el criterio de orden de los establecimientos
      criterioOrden: {
        valor: "",
        texto: "Ordenar resultados"
      },
      paginaActual: this.$store.state.paginaActual,
      tamañoPaginas: 8,
      mostrarVacantes: parseInt(localStorage.getItem("mostrarVacantes") || "0"),
      mostrarProcedimientosEspeciales: parseInt(
        localStorage.getItem("mostrarProcedimientosEspeciales") || "0"
      ),
      anioSiguiente: localStorage.getItem("anioSiguiente") || "0",
      anioAnterior: localStorage.getItem("anioAnterior") || "0",
      etapaProceso: localStorage.getItem("etapaVitrina") || "NORMAL", //Admite valores COMPLEMENTARIO / NORMAL ... Muestro / Oculta mensaje sobre establecimientos disponibles en la vitrina
      anioIndicadorCatDesempenioBasica:
        localStorage.getItem("anioIndicadorCatDesempenioBasica") || "2019",
      anioIndicadorCatDesempenioMedia:
        localStorage.getItem("anioIndicadorCatDesempenioMedia") || "2019",
      anioIndicadorCatSimceBasica:
        localStorage.getItem("anioIndicadorCatSimceBasica") || "2023",
      anioIndicadorCatSimceMedia:
        localStorage.getItem("anioIndicadorCatSimceMedia") || "2023",
      anioIndicadorCatDesarrolloSocial:
        localStorage.getItem("anioIndicadorCatDesarrolloSocial") || "2023",
      anioIndicadorCatDesarrolloMedia:
        localStorage.getItem("anioIndicadorCatDesarrolloMedia") || "2023"
    };
  },
  computed: {
    ...mapGetters(["getFiltros"]),
    establecimientos() {
      return this.$store.state.establecimientos;
    },
    region() {
      return this.$store.state.region;
    },
    comuna() {
      return this.$store.state.comuna;
    },
    nombreBusqueda() {
      return this.$store.state.nombreBusqueda;
    },
    nivel() {
      return this.$store.state.nivel;
    },
    vista() {
      return this.$store.state.vista;
    }
  },
  mounted() {
    this.tipoVista = this.vista;
  },
  methods: {
    //handler para evento scroll
    handleScroll: function() {
      window.scrollY > 0
        ? (document.getElementById("myBtn").style.display = "block")(
            (document.getElementById("flecha-abajo").style.display = "none")
          )
        : (document.getElementById("myBtn").style.display = "none");
      document.getElementById("flecha-abajo").style.display = "none";
    },
    //seter de comuna
    setComuna: function(comuna) {
      this.$store.dispatch("setComuna", { comuna: comuna });
      this.getEstablecimientos();
    },
    //seter de region
    setRegion: function(region) {
      this.$store.dispatch("setRegion", { region: region });
    },
    //seter de nivel
    setNivel: function(nivel) {
      this.$store.dispatch("setNivel", { nivel: nivel });
      this.getEstablecimientos();
    },
    //seter de nombre de busqueda de establecimientos
    setNombreBusqueda: function(nombre) {
      this.$store.dispatch("setNombre", { nombre: nombre });
    },
    //cambia vista activa en panel inferior
    cambiarVista: function(valor) {
      this.tipoVista = valor;
      this.$store.dispatch("setVista", valor);
    },
    //cambia criterio de orden para establecimientos
    cambiarOrden: function(valor) {
      this.criterioOrden = valor;
      this.getEstablecimientos();
    },
    //remueve un filtro aplicado previamente
    removerFiltro: function(valorFiltro) {
      let filtros = [...this.getFiltros];
      let tipo = filtros.find(f => f.filtros.includes(valorFiltro));
      let index = tipo.filtros.findIndex(f => f == valorFiltro);
      tipo.filtros.splice(index, 1);
      index = filtros.findIndex(f => f.tipo == tipo.tipo);
      if (tipo.filtros.length == 0) {
        filtros.splice(index, 1);
      } else {
        filtros[index] = tipo;
      }

      this.$store.dispatch("setFiltros", filtros);
      this.getEstablecimientos();
    },
    //modifica los filtros aplicados segun corresponda
    modificarFiltros: function(filtrosNuevos, tipoFiltros) {
      let filtrosExistentes = [...this.getFiltros];
      let filtroModificar = filtrosExistentes.find(f => f.tipo == tipoFiltros);
      if (filtroModificar) {
        filtroModificar.filtros = filtrosNuevos;
        filtrosExistentes[tipoFiltros] = filtroModificar;
      } else {
        filtroModificar = { tipo: tipoFiltros, filtros: filtrosNuevos };
        filtrosExistentes.push(filtroModificar);
      }

      this.$store.dispatch("setFiltros", filtrosExistentes);
      this.getEstablecimientos();
    },
    //limpiar orden de establecimientos
    limpiarOrden() {
      this.criterioOrden = {
        valor: "",
        texto: "Ordenar resultados"
      };
    },
    //realiza la busqueda de establecimientos
    getEstablecimientos: async function() {
      if (this.$store.state.comuna.nombreComuna) {
        this.$emit("cargar");
        let filtros = [...this.getFiltros];

        //agrupa filtros para enviarlos por consulta
        let est = await ApiEstablecimientos.getEstablecimientos(
          ApiRegiones.traduccionComunasApi(
            this.$store.state.comuna.nombreComuna
          ), //comuna
          filtros.find(f => f.tipo == "dependencia"), //dependencia
          this.$store.state.nivel ? this.$store.state.nivel : "", //nivel
          filtros.find(f => f.tipo == "genero"), //generos
          filtros.find(f => f.tipo == "jornadas"), //jornadas
          this.$store.state.nombreBusqueda &&
            this.$store.state.nombreBusqueda.length > 4
            ? ApiRegiones.traduccionComunasApi(this.$store.state.nombreBusqueda)
            : "", //nombre
          filtros.find(f => f.tipo == "otros"), //otros
          filtros.find(f => f.tipo == "programa"), //pie
          this.criterioOrden.valor, //orden
          this //componente
        );
        this.$store.dispatch("setEstablecimientos", { establecimientos: est });
        this.$emit("cargado");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Inicio.vue